import isString from './is-string';
import toString from './to-string';
import { default as measureTextWidth } from './measure-text-width';
/**
 * è·åææ¬ç ... ææ¬ã
 * ç®æ³ï¼åå°æ¯æ¬¡ measureText çé¿åº¦ï¼measureText çæ§è½è·å­ç¬¦ä¸²æ¶é´ç¸å³ï¼ï¼
 * 1. åéè¿ STEP éæ­¥è®¡ç®ï¼æ¾å°æåä¸ä¸ªå°äº maxWidth çå­ç¬¦ä¸²
 * 2. ç¶åå¯¹æåè¿ä¸ªå­ç¬¦ä¸²äºåè®¡ç®
 * @param text éè¦è®¡ç®çææ¬, ç±äºåå²åå  é¤äºæ¯æstringï¼è¿æ¯æç©ºå¼,numberåæ°ç»ç­
 * @param maxWidth æå¤§å®½åº¦
 * @param font å­ä½
 * @param str è¦æ¿æ¢çææ¬
 */
export default (function (text, maxWidth, font, str) {
    if (str === void 0) { str = '...'; }
    var STEP = 16; // æ¯æ¬¡ 16ï¼è°åå·¥ç¨å¸
    var PLACEHOLDER_WIDTH = measureTextWidth(str, font);
    var leftText = !isString(text) ? toString(text) : text;
    var leftWidth = maxWidth;
    var r = []; // æç»çåæ®µå­ç¬¦ä¸²
    var currentText;
    var currentWidth;
    if (measureTextWidth(text, font) <= maxWidth) {
        return text;
    }
    // é¦åéè¿ step è®¡ç®ï¼æ¾åºæå¤§çæªè¶åºé¿åº¦ç
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // æ´æ°å­ç¬¦ä¸²
        currentText = leftText.substr(0, STEP);
        // è®¡ç®å®½åº¦
        currentWidth = measureTextWidth(currentText, font);
        // è¶åºå©ä½å®½åº¦ï¼ååæ­¢
        if (currentWidth + PLACEHOLDER_WIDTH > leftWidth) {
            if (currentWidth > leftWidth) {
                break;
            }
        }
        r.push(currentText);
        // æ²¡æè¶åºï¼åè®¡ç®å©ä½å®½åº¦
        leftWidth -= currentWidth;
        leftText = leftText.substr(STEP);
        // å­ç¬¦ä¸²æ´ä½æ²¡æè¶åº
        if (!leftText) {
            return r.join('');
        }
    }
    // æä¸çæåä¸ä¸ª STEPï¼ä½¿ç¨ 1 éå¢ï¼ç¨äºåæææ´é«ï¼
    // eslint-disable-next-line no-constant-condition
    while (true) {
        // æ´æ°å­ç¬¦ä¸²
        currentText = leftText.substr(0, 1);
        // è®¡ç®å®½åº¦
        currentWidth = measureTextWidth(currentText, font);
        // è¶åºå©ä½å®½åº¦ï¼ååæ­¢
        if (currentWidth + PLACEHOLDER_WIDTH > leftWidth) {
            break;
        }
        r.push(currentText);
        // æ²¡æè¶åºï¼åè®¡ç®å©ä½å®½åº¦
        leftWidth -= currentWidth;
        leftText = leftText.substr(1);
        if (!leftText) {
            return r.join('');
        }
    }
    return "" + r.join('') + str;
});
//# sourceMappingURL=get-ellipsis-text.js.map